import { StateCreator } from 'zustand';

export interface NotesSlice {
    noteCreated: boolean;
    setNoteCreated: () => void;
    clearNote: () => void;
}

export const createNoteSlice: StateCreator<NotesSlice> = (set, get) => ({
    noteCreated: false,
    setNoteCreated: () => {
        set({ noteCreated: true });
    },
    clearNote: () => {
        set({ noteCreated: false });
    }
});
